import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TemplateRevisionId = Brand<bigint, 'TemplateRevisionId'>;
export const TemplateRevisionId = createBranded<TemplateRevisionId>();
